import { vars } from '../../vars';
import {
  buildEnglishIqResultImgR2Key,
  type IBuildEnglishIqResultImgArgs,
} from './build-english-iq-result-img-r2-key';

export function buildEnglishIqResultImgUrl(args: IBuildEnglishIqResultImgArgs): string {
  return `${vars.s3.publicBucket.publicUrl}/${buildEnglishIqResultImgR2Key(args)}`;
}
